import { ref, watch, computed } from '@vue/composition-api';
import axios from '@axios';
import { useUtils as useI18nUtils } from '@core/libs/i18n';

const { i18n } = useI18nUtils();
function i18nT(str) {
  return i18n(str);
}

export default function useAbridgedTransactionList() {
  const refDocumentListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    { key: 'date', label: i18nT('Date'), sortable: true },
    { key: 'amount', label: i18nT('Amount'), sortable: true },
    { key: 'DebtorName', label: i18nT('Recipient / Sender'), sortable: true },
    { key: 'name', label: i18nT('Description'), sortable: true, thClass: 'pl-1', tdClass: 'pl-1' },
    { key: 'bank_account', label: i18nT('Bank'), sortable: true },
    { key: 'currency', label: i18nT('Currency'), sortable: true }
  ];

  const perPage = ref(10);
  const totalDocuments = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref('');
  const sortBy = ref('id');
  const isSortDirDesc = ref(true);
  const transactions = ref([]);
  const bankAccount = ref('');
  const currency = ref('');
  const matchedStatus = ref('');
  const startDate = ref('');
  const endDate = ref('');
  const amountFrom = ref(0);
  const amountTo = ref(0);

  const dataMeta = computed(() => {
    const count = refDocumentListTable.value
        ? refDocumentListTable.value.localItems.length
        : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (count ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + count,
      of: totalDocuments.value
    };
  });

  const refetchData = () => {
    if (refDocumentListTable.value) {
      refDocumentListTable.value.refresh();
    }
  };

  // Watch all filter criteria including amount range
  watch(
      [
        currentPage,
        perPage,
        searchQuery,
        bankAccount,
        currency,
        matchedStatus,
        startDate,
        endDate,
        amountFrom,
        amountTo
      ],
      refetchData
  );

  const fetchDocuments = (ctx, callback) => {
    const params = {
      page: currentPage.value,
      show_per_page: perPage.value,
      sort_by: sortBy.value,
      sort_order: isSortDirDesc.value ? 'DESC' : 'ASC',
      search: searchQuery.value,
      start_date: startDate.value,
      end_date: endDate.value,
      ...(bankAccount.value && { 'filters[bank_account]': bankAccount.value }),
      ...(currency.value && { 'filters[currency]': currency.value }),
      ...(matchedStatus.value && { 'filters[matched]': matchedStatus.value }),
      ...(amountFrom.value != null && { 'filters[amount_from]': amountFrom.value }),
      ...(amountTo.value != null && { 'filters[amount_to]': amountTo.value })
    };

    axios.get('transactions', { params }).then(({ data }) => {
      const items = data.data.bank_transactions || [];
      transactions.value = items;
      callback(items);
      totalDocuments.value = data.data.pagination.records_count;
    });
  };

  return {
    fetchDocuments,
    tableColumns,
    perPage,
    currentPage,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refDocumentListTable,
    totalDocuments,
    bankAccount,
    currency,
    amountFrom,
    amountTo,
    transactions,
    matchedStatus,
    startDate,
    endDate,
    refetchData
  };
}
